module.exports = __webpack_public_path__ + "img/undraw_judge-large.cdf1ba3f.webp";